import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-left',
  templateUrl: './icon-arrow-left.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowLeftComponent {}
